export default "__VITE_ASSET__3c84eea1__"